import { Controller } from "@hotwired/stimulus"

// Édition en place d'une valeur de tableau — remplace la gem best_in_place,
// retirée en vague 5. Le span est produit par le helper `inline_edit`
// (app/helpers/inline_edit_helper.rb).
//
// PARITÉ : legacy.js branchait `.on("ajax:success ajax:error", location.reload)`
// sur tous les champs best_in_place — la page se rechargeait donc après CHAQUE
// édition, réussie ou non. On garde ce comportement : aucun re-rendu côté
// client, aucun affichage d'erreur ; c'est le rechargement qui affiche la
// valeur enregistrée et le flash du serveur.
//
// Deux formes seulement, celles qui étaient utilisées :
//   - "input"    : clic → champ texte, Entrée/blur enregistre, Échap annule ;
//   - "checkbox" : clic → bascule immédiate (☐/☑), pas d'étape d'édition.
export default class extends Controller {
  static values = {
    url: String,
    model: String,
    attribute: String,
    type: { type: String, default: "input" },
    raw: String,
    checked: Boolean,
    size: Number
  }

  connect() {
    this.editing = false
  }

  // data-action="click->inline-edit#activate"
  activate(event) {
    event.preventDefault()
    // Le handler délégué de legacy.js (`$('.rowClickable').on('click', 'tr')`)
    // envoie la page sur le lien de la ligne dès qu'on clique une cellule :
    // dans campaigns#show, la navigation partait AVANT que la requête de
    // best_in_place n'aboutisse. Couper la remontée règle le conflit.
    event.stopPropagation()

    if (this.typeValue === "checkbox") {
      this.submit(this.checkedValue ? "false" : "true")
    } else {
      this.openInput()
    }
  }

  openInput() {
    if (this.editing) return
    this.editing = true
    this.originalContent = this.element.innerHTML

    const input = document.createElement("input")
    input.type = "text"
    input.value = this.rawValue
    input.className = "inline-edit-input"
    if (this.hasSizeValue) input.size = this.sizeValue

    input.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        event.preventDefault()
        this.submit(input.value)
      } else if (event.key === "Escape") {
        event.preventDefault()
        this.cancel()
      }
    })
    // `editing` retombe à false dans submit()/cancel() : le blur qui suit une
    // validation au clavier ou une annulation ne déclenche pas un second envoi.
    input.addEventListener("blur", () => {
      if (this.editing) this.submit(input.value)
    })

    this.element.replaceChildren(input)
    input.focus()
    input.select()
  }

  cancel() {
    this.editing = false
    this.element.innerHTML = this.originalContent
  }

  submit(value) {
    this.editing = false

    const body = new URLSearchParams()
    body.append(`${this.modelValue}[${this.attributeValue}]`, value)

    // Format identique à celui de best_in_place : PATCH form-encodé
    // `modele[attribut]=valeur`, négocié en JSON (les contrôleurs visés
    // déclarent `respond_to :html, :json`).
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      "X-Requested-With": "XMLHttpRequest"
    }
    // Ces contrôleurs font tous `skip_before_action :verify_authenticity_token`
    // et le layout n'émet pas de csrf_meta_tags : l'en-tête n'est posé que s'il
    // existe, pour rester correct si la protection est rétablie un jour.
    const token = document.querySelector("meta[name='csrf-token']")
    if (token) headers["X-CSRF-Token"] = token.content

    fetch(this.urlValue, {
      method: "PATCH",
      headers,
      body,
      credentials: "same-origin"
    }).finally(() => window.location.reload())
  }
}
